import { computed } from 'vue';
import DashboardService from '@/services/DashboardService';
export const colorSchema = {
  A: '#0047AB', // Cobalt Blue
  B: '#9A2A2A', // Garnet
  C: '#3CB371', // Medium Sea Green
  D: '#6A5ACD', // Amethyst
  E: '#9B2335', // Velvet Red
  F: '#6C2A2A', // Oxide Red
  G: '#8B008B', // Dark Magenta
  H: '#FF69B4', // Hot Pink
  I: '#3E8E41', // Hunter Green
  J: '#001F3F', // Navy
  K: '#D21F3C', // Raspberry
  L: '#C04000', // Mahogany
  M: '#9B2D51', // Quinacridone Magenta
  N: '#4B0082', // Indigo
  O: '#D24D00', // Terracotta
  P: '#4682B4', // Steel Blue
  Q: '#663399', // Lavender
  R: '#6F2C91', // Berry Purple
  S: '#D6A72D', // Yellow Ochre
  T: '#635147', // Umber
  U: '#722F3F', // Wine
  V: '#B22222', // Firebrick
  W: '#228B22', // Forest Green
  X: '#0047AB', // Xenon Blue
  Y: '#8B008B', // Dark Magenta
  Z: '#C04000', // Mahogany
};

export function debounce(fn, delay) {
  let timeoutID;
  return function (...args) {
    clearTimeout(timeoutID);
    timeoutID = setTimeout(() => {
      fn.apply(this, args);
    }, delay);
  };
}

export const goToURL = (event, url) => {
  event.stopPropagation();
  if (!/^https?:\/\//i.test(url)) {
    url = `https://${url}`;
  }
  window.open(url, '_blank', 'noopener,noreferrer');
};

export const getInitials = (name) => {
  if (name) {
    const words = name.split(' ');
    if (words.length === 1) {
      return words[0].charAt(0).toUpperCase();
    }
    const firstInitial = words[0].charAt(0).toUpperCase();
    const lastInitial = words[words.length - 1].charAt(0).toUpperCase();
    return firstInitial + lastInitial;
  } else return 'N/A';
};

export const getProfileColor = (data) => {
  const updated = renderEntity(data);
  const color = colorSchema[updated.charAt(0).toUpperCase()];
  return color ? `bg-[${color}]` : 'profile_default_color';
};

export const placeholderImagesToSkip = [
  'https://static.licdn.com/aero-v1/sc/h/9c8pery4andzj6ohjkjp54ma2',
  'https://static.licdn.com/sc/h/244xhbkr7g40x6bsu4gi6q4ry',
  'https://static.licdn.com/aero-v1/sc/h/244xhbkr7g40x6bsu4gi6q4ry',
  'https://static-exp1.licdn.com/sc/h/djzv59yelk5urv2ujlazfyvrk',
];

export function renderEntity(entity) {
  if (entity.title) {
    return entity.title;
  } else if (entity.name) {
    return entity.name;
  } else if (entity.first_name || entity.last_name) {
    return `${entity.first_name || ''} ${entity.last_name || ''}`.trim();
  } else if (entity.website) {
    return entity.website;
  } else if (entity.email) {
    return entity.email;
  } else if (entity && typeof entity !== 'object') {
    return entity;
  } else {
    return '';
  }
}

export const checkUserSeatEnabled = async () => {
  try {
    const response = await DashboardService.getOrCreateAccount();
    if (response?.success) {
      return response?.account?.UserSeatEnabled;
    }
  } catch (error) {
    console.error('An error occurred while checking user seat enabled: ', error);
    return false;
  }
};

// Simple function to get environment from URL
export const getEnvironmentFromUrl = () => {
  const currentUrl = window.location.href;

  if (currentUrl.includes('billing.superagi.com') || currentUrl.includes('sales.superagi.com')) {
    return 'production';
  }

  if (currentUrl.includes('billing-staging.superagi.com') || currentUrl.includes('staging')) {
    return 'staging';
  }

  if (currentUrl.includes('localhost') || currentUrl.includes('development')) {
    return 'local';
  }

  return 'local'; // default
};

// Simple function to get V1 workspace IDs based on environment
export const getV1WorkspaceIds = () => {
  const environment = getEnvironmentFromUrl();

  const v1Workspaces = {
    production: ['12802', '12806', '12808', '12809', '12919', '12916', '7561'],
    staging: 'all', // Enable V1 for all workspaces on staging
    local: 'all',
  };

  return v1Workspaces[environment] || [];
};

// Simple function to check if current workspace should show V1
export const shouldShowV1ForCurrentWorkspace = () => {
  const currentWorkspaceId = localStorage.getItem('billing_workspace_id');
  if (!currentWorkspaceId) return false;

  const v1WorkspaceIds = getV1WorkspaceIds();

  // If staging is set to 'all', show V1 for all workspaces
  if (v1WorkspaceIds === 'all') {
    return true;
  }

  return v1WorkspaceIds.includes(currentWorkspaceId);
};
